// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"DeleteModal_deleteButton__1CA8g","deleteMessage":"DeleteModal_deleteMessage__1GYWj"};